import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetch live Google Business Profile summary (rating + total count) via our
 * backend proxy. Falls back to the provided static values on any failure.
 */
export default function useGoogleReviews(fallback = { rating: 5.0, total: 7 }) {
  const [data, setData] = useState({ ...fallback, source: "static", loading: true });

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/reviews/google`, { timeout: 8000 })
      .then((res) => {
        if (cancelled || !res.data) return;
        const rating = typeof res.data.rating === "number" ? res.data.rating : fallback.rating;
        const total = typeof res.data.total === "number" ? res.data.total : fallback.total;
        setData({
          rating,
          total,
          source: res.data.source === "cache" || res.data.source === "live" ? "live" : "static",
          loading: false,
        });
      })
      .catch(() => {
        if (!cancelled) setData({ ...fallback, source: "static", loading: false });
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}
